<template>
  <div class="home">
    <Navbar :is-active="1"></Navbar>
    <div class="body">
      <CommercialSidebar active="sucursales" />
      <div class="body__containt">
        <div class="page__title">
          <open-arrow></open-arrow>
          <h2>Sucursales</h2>
        </div>
        <div class="page__filters">
          <input
            type="text"
            v-model="branch_code"
            placeholder="Código de Tienda"
            @keyup="search"
            @keypress="onlynumber(e)"
          />
          <input
            type="text"
            v-model="branch_nickname"
            placeholder="Alias"
            @keyup="search"
          />
<!--          <input-->
<!--            type="text"-->
<!--            v-model="branch_dep_id"-->
<!--            placeholder="Departamento"-->
<!--            @keyup="search"-->
<!--          />-->
<!--          <input-->
<!--            type="text"-->
<!--            v-model="branch_pro_id"-->
<!--            placeholder="Provincia"-->
<!--            @keyup="search"-->
<!--          />-->
            <select style="width:15%;" v-model="branch_dep_id" @change="dataDepartamento($event)">
              <option disabled value="0" >Departamento</option>
              <option v-for="deparment in departments" :value="deparment.id">{{ deparment.name }}</option>
            </select>

            <select style="width:15%;" v-model="branch_pro_id" @change="dataProvincia()">
              <option disabled value="0" >Provincia</option>
              <option v-for="province in provincesOptions" :value="province.id">{{ province.name }}</option>
            </select>

            <select style="width:15%;" v-model="branch_dis_id" @change="dataUbigeo()">
              <option disabled value="0" >Distrito</option>
              <option v-for="distrito in districtsOptions" :value="distrito.id">{{ distrito.name }}</option>
            </select>

<!--          <input-->
<!--            type="text"-->
<!--            v-model="branch_dis_id"-->
<!--            placeholder="Distrito"-->
<!--            @keyup="search"-->
<!--          />-->
          <select v-model="branch_status" @change="search">
            <option selected disabled value="3">Estado</option>
            <option value="1">Acivado</option>
            <option value="0">Desactivado</option>
          </select>
          <p @click="clean_filters()" class="clean_filter">Limpiar Filtros</p>
        </div>
        <br>
        <div class="page__buttons">
          <button class="button" @click="AddSucursal">
            Nueva Sucursal <i class="fas fa-plus"></i>
          </button>
          <button @click="importBranchOffice()" class="button">
            Carga Masiva <i class="fas fa-upload"></i>
          </button>
          <ButtonExport
            :columns="columns"
            :data="branchoffice_export"
            :sheet-name="'Datos Sucursales'"
            :file-name="'Reporte Sucursales'"
          />
        </div>
        <div class="page__table">
          <div class="table-headers">
            <p v-for="{ label } of columns" :key="label">{{ label }}</p>
            <p>Accion</p>
          </div>
          <div class="table-body">
            <div v-for="branch of branchoffice" :key="branch.id">
              <div class="data">
                <p >
                  {{ codeFormat(branch.branch_code) }}
                </p>
                <p>{{ branch.branch_name }}</p>
                <p>{{ branch.branch_nickname }}</p>
                <p>{{ branch.branch_description }}</p>
                <p>{{ branch.branch_direction }}</p>
                <p>{{ branch.branch_reference }}</p>
                <p>{{ conditionalFormatValue(branch.branch_inside_mall) }}</p>
                <div class="dropdown" >
                  <button class="button" @click="show('id-dropdown-content'+branch.id)">
                    <i class="fa fa-ellipsis" style="color: red"></i>
                  </button>
                  <div @mouseleave="show('id-dropdown-content'+branch.id)" class="dropdown-content" :id="'id-dropdown-content'+branch.id">
                      <button class="dropdown-item" @click="openModal(branch.id)">
                        <i class="fas fa-bars"></i> Desplegar modal
                      </button>
                      <router-link :to="{ path: '/Client/ShowBranchOffice', query: { id: branch.id }}" class="dropdown-item">
                        <i class="far fa-eye " ></i> Ver Detalle
                      </router-link>
                      <div class="dropdown-item-special">
                        Activado
                        <input
                            :id="'check_'+branch.id"
                            type="checkbox"
                            :checked="(branch.branch_status === 1)"
                            class="dropdown-checkbox"
                            @change="activateBranchOffice($event, branch.id)"
                        />
                        <label class="wrapper" :for="'check_'+branch.id">
                          <span class="circle"></span>
                        </label>
                      </div>
                  </div>
                </div>
              </div>
              <div>
              </div>
            </div>

             <div style="text-align: center;" v-if="empty">
              <h4 style="color: #938f8f; padding: 50px;">No se encontraron datos</h4>
            </div>
          </div>
        </div>
        <div class="page__pagination">
          <Pagination
              :data="pagination"
              v-on:changePage="handleClickInParent"
          />
        </div>
        <vue-final-modal v-if="dataModal" v-model="showModal"  classes="modal-container" content-class="modal-content">
          <h2>Datos sucursal: </h2>
          <div id="columnas">
            <li> <span style="font-weight: bold;"> Código de Tienda: </span>  <span>{{ dataModal.branch_code}} </span></li>
            <li> <span style="font-weight: bold;"> Nombre : </span>  <span>{{ dataModal.branch_name}} </span></li>
            <li> <span style="font-weight: bold;"> Nickname: </span>  <span>{{ dataModal.branch_nickname}} </span></li>
            <li> <span style="font-weight: bold;"> Descripción : </span>  <span>{{ dataModal.branch_description}} </span></li>
            <li> <span style="font-weight: bold;"> Descripción de Mall: </span>  <span>{{ dataModal.branch_direction_mall}} </span></li>
            <li> <span style="font-weight: bold;"> Dirección: </span>  <span>{{ dataModal.branch_direction}} </span></li>
            <li> <span style="font-weight: bold;"> Latitud : </span>  <span>{{ dataModal.branch_latitude}} </span></li>
            <li> <span style="font-weight: bold;"> longitud: </span>  <span>{{ dataModal.branch_length}} </span></li>
            <li> <span style="font-weight: bold;"> Referencia : </span>  <span>{{ dataModal.branch_reference}} </span></li>
            <li> <span style="font-weight: bold;"> Nombre mall : </span>  <span>{{ dataModal.branch_name_mall}} </span></li>
            <li> <span style="font-weight: bold;"> Departamento: </span>  <span>{{ dataModal.department}} </span></li>
            <li> <span style="font-weight: bold;"> Provincia : </span>  <span>{{ dataModal.province}} </span></li>
            <li> <span style="font-weight: bold;"> Distrito : </span>  <span>{{ dataModal.district}} </span></li>
          </div>

          <div class="page__table">
            <h4>Productos</h4>
            <section class="page__filters" style="align-items: center; display: flex; flex-direction: row; justify-content: space-between;">
              <div class="input" style="align-items: center; display: flex; flex-direction: row; justify-content: space-between;">
                <input  @keyup="searchProducts" type="text" v-model="search_product" placeholder="Buscar producto" style="outline: none; padding: 0px 0px; border: 0px !important;">
                <i class="fas fa-search"></i>
              </div>
            </section>

            <div class="table-headers">
              <p v-for="{ label } of columnsModal" :key="label">{{ label }}</p>
            </div>
            <div class="table-body">
              <div class="data" v-for="product of dataModal.products.data" :key="product.id" style="justify-content: center;">
                  <p>{{ product.product_code }}</p>
                  <p>{{ product.product_name }}</p>
                  <p>{{ product.product_descripcion }}</p>
                  <p>{{ product.type }}</p>
              </div>

              <div style="text-align: center;" v-if="productEmpty">
                <h4 style="color: #938f8f; padding: 50px;">No se encontraron datos</h4>
              </div>
            </div>

            <div class="page__pagination" style="padding-top: 2%;">
              <Pagination
                  :data="paginationProduct"
                  v-on:changePage="handleClickInProduct"
              />
            </div>

          </div>
          <div class="page__buttons" style="padding-top: 2%;">
            <button style="background: #ff3128; width: 250px;padding: 15px 20px;border-radius: 15px;font-size: 17px;color: #fff;border: none;display: flex;align-items: center;justify-content: space-between;" @click="this.showModal = false">
              <span>Cerrar</span>
              <i class="fa fa-times-circle"></i>
            </button>
          </div>
        </vue-final-modal>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import Navbar from '@/components/NavBar'
  import Dropdown from '@/components/Dropdown.vue'
  import ButtonExport from '@/components/ButtonExport.vue'
  import { codeFormat, conditionalFormatValue } from '@/utils/formats'
  import Pagination from '@/components/Pagination.vue'
  import Rows from '@/components/Rows.vue'
  import { VueFinalModal } from 'vue-final-modal'
  import OpenArrow from '@/components/OpenArrow.vue'
  import CommercialSidebar from '@/components/CommercialSidebar.vue'
  import $ from 'jquery'

  export default {
    name: 'Home',
    components: {
      Navbar,
      ButtonExport,
      Dropdown,
      Pagination,
      Rows,
      VueFinalModal,
      OpenArrow,
      CommercialSidebar
    },
    data() {
      return {
        role: localStorage.getItem('role'),
        type: 'BranchOffice',
        branch_code: '',
        showDropdwon: true,
        checked: true,
        productPage: 1,
        search_product: '',
        dataModal: null,
        branch_name: '',
        showModal: false,
        branch_nickname: '',
        branch_dep_id: 0,
        branch_pro_id: 0,
        branch_dis_id: 0,
        sucu: '',
        mensaje: '',
        page: '',
        branch_status: 3,
        url_importar: '',
        departments: [],
        provinces: [],
        districts: [],
        branchoffice_export: [],
        pagination: [],
        paginationProduct: [],
        provincesOptions: [],
        districtsOptions: [],
        empty: [],
        modal: [],
        branchoffice: [],
        columnsModal:[
          { label: 'Codigo producto', field: 'product_code' },
          { label: 'Nombre', field: 'product_name' },
          { label: 'Descripción', field: 'product_descripcion' },
          { label: 'Tipo', field: 'type' },
        ],
        columns: [
          {
            label: 'Código de Tienda',
            field: 'branch_code',
            dataFormat: this.codeFormat
          },
          { label: 'Nombre Sucursal', field: 'branch_name' },
          { label: 'Alias', field: 'branch_nickname' },
          { label: 'Descripción', field: 'branch_description' },
          { label: 'Dirección', field: 'branch_direction' },
          { label: 'Referencia', field: 'branch_reference' },
          {
            label: 'Dentro del Mall',
            field: 'branch_inside_mall',
            dataFormat: this.conditionalFormatValue
          }
        ]
      }
    },
    methods: {
      onlynumber(evt){
        evt = (evt) ? evt : window.event
        const charCode = (evt.which) ? evt.which : evt.keyCode
        if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
          evt.preventDefault()
        } else {
          return true
        }
      },
      closeAccion(){
        console.log('ingreso1')
      },
      backCompany(){
        this.$router.push('/comercial')
      },
      getCheck(){
        return true
      },
      activateBranchOffice(e, id){
        let data = {
          branch_status: (e.target.checked) ? 1 : 0
        }
        axios.post('general/branchoffice/branchoffice/'+id, data)
        this.search()
        this.$swal({
          position: 'center',
          icon: 'success',
          title: (e.target.checked) ? 'Activado correctamente': 'Desactivado correctamente',
          showConfirmButton: false,
          timer: 2000
        })
      },
      openModal(divID, page = 1, search = ''){
        if(divID){
          this.show('id-dropdown-content'+divID)
          if (this.sucu !== divID){
            this.search_product = ''
          }
            this.sucu = divID
        }
        this.showModal = true
        axios.get("general/branchoffice/"+this.sucu, {
          params: { page: page, data: search }
        }).then(res => {
          this.dataModal = res.data.data
          if (res.data.data.products.total > 0){
            this.productEmpty = false
            this.paginationProduct = res.data.data.products
          }else{
            this.productEmpty = true
            this.paginationProduct = {}
          }
        })
      },
      show(divID){
        if (!$("body").hasClass("cerrarModal")){
          $('#'+divID).fadeIn();
          setTimeout(function () {
            $("body").addClass("cerrarModal");
          }, 10);
        }
      },
      handleClickInParent: function(page) {
        this.page = page
        this.search()
      },
      handleClickInProduct: function(page) {
        this.openModal(null, page, this.search_product)
      },
      hidden(){
        var d = document.getElementById("body__sidebar")
        d.className += " open"
        var div_close = document.getElementById("div_close");
        div_close.style.display = 'none'

        var div_open = document.getElementById("div_open");
        div_open.style.display = 'block'
      },
      open(){
        var d = document.getElementById("body__sidebar");
        d.classList.remove("open");
        var div_open = document.getElementById("div_open");
        div_open.style.display = 'none'

        var div_close = document.getElementById("div_close");
        div_close.style.display = 'block'
      },
      search: function() {
        var self = this;
        this.page = (this.page) ? this.page : 1
        this.timeout = setTimeout(function () {
          let paramSearch = {
            branch_code: self.branch_code,
            branch_nickname: self.branch_nickname,
            nombre_producto: self.nombre_producto,
            branch_pro_id: self.branch_pro_id,
            branch_dis_id: self.branch_dis_id,
            branch_dep_id: self.branch_dep_id,
            branch_status: self.branch_status,
          }
          this.getall(this.page, paramSearch)
        }.bind(this), 500);
      },
      searchProducts: function() {
        var self = this;
        this.timeout = setTimeout(function () {
          this.openModal(null, 1, self.search_product)
        }.bind(this), 500);
      },
      dataDepartamento(id){
        var temporal=[];
        this.provinces.forEach(item=>{
        if((item.department_id)===this.branch_dep_id)
            temporal.push(item);
        })
        this.districtsOptions = temporal;
        this.provincesOptions=temporal;
        this.search()
      },
      clean_filters(){
        this.branch_dep_id = 0
        this.branch_pro_id = 0
        this.branch_dis_id = 0
        this.branch_code = ''
        this.branch_nickname = ''
        this.branch_status = 3
        this.getall()
      },
      dataProvincia(){
        var temporal=[];
        this.districts.forEach(item=>{
          if((item.province_id)===this.branch_pro_id)
            temporal.push(item);
        })
        this.districtsOptions=temporal;
        this.search()
      },
      dataUbigeo(){
        this.ubigeo = this.branch_dis_id.id
        this.search()
      },
      async getUbigeo(){
      await axios.get("general/ubigeo")
        .then(res => {
          this.departments = res.data.data.department
          this.provinces = res.data.data.province
          this.districts = res.data.data.district
        })
      },
      codeFormat,
      conditionalFormatValue,
      handleClick() {
        // localStorage.removeItem('token')
        this.$router.push('/login')
      },
      async getBrand(){
        const params = {
          branch_company_id:  localStorage.getItem('company_id')
        }
        await axios.get('general/elements/brand', params).then(res => {
          this.brand = res.data.data
        })
      },
      async getall(page = 1, paramSearch = {}) {
        // let result = axios.get("general/branchoffice/"+1).then(res => {
        //   this.dataModal = res.data.data
        // })
       await axios.get('general/branchoffice', {params: {
            page: page,
            branch_company_id:localStorage.getItem('company_id'),
            branch_code: ( typeof paramSearch.branch_code === 'undefined' || paramSearch.branch_code === '' ) ? null : parseInt(paramSearch.branch_code),
            branch_nickname: paramSearch.branch_nickname,
            branch_dep_id: (paramSearch.branch_dep_id === 0) ? null : paramSearch.branch_dep_id,
            branch_dis_id: (paramSearch.branch_dis_id === 0) ? null : paramSearch.branch_dis_id,
            branch_pro_id: (paramSearch.branch_pro_id === 0) ? null : paramSearch.branch_pro_id,
            branch_status: (paramSearch.branch_status === 3) ? null : paramSearch.branch_status,
        },headers: {
           'Authorization': `Bearer ${localStorage.getItem('token')}`
         }}).then( res => {
           this.url_importar = res.data.url
          if (res.data.data.total > 0){
            this.branchoffice = res.data.data.data
            this.branchoffice_export = res.data.export
            this.pagination = res.data.data
            this.empty = false
          }else{
            this.branchoffice = {}
            this.pagination = {}
            this.empty = true
          }
        })
      },
      AddSucursal() {
        this.$router.push('/Client/AddBranchOffice')
      },
      showBranchOffice(id) {
        this.$router.push({
          path: '/Client/ShowBranchOffice',
          query: { id: id }
        })
      },
      async importBranchOffice() {
        let self =  this
        const { value: file } = await this.$swal({
          title: 'IMPORTAR SUCURSALES',
          html: 'descarga el formato <a href="'+this.url_importar+'">aquí</a><br><br><p>Nota:<br> El archivo debe subirse comprimido en zip y con el nombre fm_import_branch_office.xlsx</p>',
          input: 'file',
          inputAttributes: {
            accept: '.zip',
            'aria-label': ''
          },
          showCancelButton: true,
          confirmButtonText: 'Importar',
          cancelButtonText: 'Cancelar',
          cancelButtonColor: '#ff3128',
          confirmButtonColor: '#32ba7c',
          showLoaderOnConfirm: true
        })

        if (file) {
          const reader = new FileReader()
          const formData = new FormData();
          formData.append('file', file);
          formData.append('company_id', localStorage.getItem('company_id'));
          reader.onload = async e => {
            const response = await axios.post('general/branchoffice/import', formData).then(
                res => {
                  this.mensaje = ''
                  if (res.data.success){
                    let fl = 0
                    Object.entries(res.data.data).forEach(item=>{
                      let color = ''
                      if (!item[1].status){
                        color = 'red'
                        fl++
                      }
                      this.mensaje += '<p style="color:'+color+'">'+item[1].mensaje + '</p>'
                    })
                    let sms = ''
                    let icon = ''
                    if (Object.entries(res.data.data).length === fl){
                      sms = 'No se importó porque el archivo tiene errores'
                      icon = 'error'
                    }else if (fl===0){
                      sms = 'Se importó correctamente'
                      icon = 'success'
                    }else{
                      sms = 'Se importó pero algunas filas tienen errores, por favor revisar los registros de resultado'
                      icon = 'warning'
                    }

                    this.getall()
                    this.$swal({
                      position: 'center',
                      icon: icon,
                      title: sms,
                      html: '<div style="max-height: 200px; min-height: 30px">'+this.mensaje+'</div>',
                      showConfirmButton: true,
                      confirmButtonColor: '#32ba7c',
                      confirmButtonText: 'Aceptar'
                    })
                  }else {
                    this.$swal({
                      position: 'center',
                      icon: 'error',
                      title: 'Ocurrio un error',
                      showConfirmButton: false,
                      timer: 2000
                    })
                  }
                }
            ).catch(
                function (error) {
                  self.$swal({
                    position: 'center',
                    icon: 'error',
                    title: 'Formato Invalido',
                    showConfirmButton: false,
                    timer: 2000
                  })
                }
            )
          }
          reader.readAsDataURL(file)
        }else{
          this.$swal({
            position: 'center',
            icon: 'error',
            title: 'Adjuntar archivo',
            showConfirmButton: false,
            timer: 2000
          })
        }
      },
      deleteBranchOffice(branch_id) {
        this.$swal({
          title: '¿Estas seguro de eliminar el sucursal?',
          text: '',
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Eliminar',
          cancelButtonText: 'Cancelar'
        }).then(result => {
          if (result.isConfirmed) {
            let result = axios
              .delete('general/branchoffice/' + branch_id)
              .then(res => {
                if (res.data.success) {
                  this.$swal({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Se elimino correctamente',
                    showConfirmButton: false,
                    timer: 2000
                  })
                  this.$router.go(0)
                } else {
                  this.$swal({
                    position: 'top-end',
                    icon: 'error',
                    title: 'Ocurrio un problema',
                    showConfirmButton: false,
                    timer: 2000
                  })
                }
              })
          }
        })
      },
    },
    created() {
      if (localStorage.getItem('token')) {
        this.getall()
        this.getBrand()
        this.getUbigeo()
        this.company_name = localStorage.getItem('company_name');
      } else {
        this.$router.push('/login')
      }
    },
    computed:{
      // modal: function () {
      //   window.addEventListener('foo-key-localstorage-changed', (event) => {
      //     axios.get("general/branchoffice/"+event.detail.id, {params: { page: this.productPage, data: this.search_product }}).then(res => {
      //       this.dataModal = res.data.data
      //     }).catch(function(e) {
      //       console.log(e)
      //     })
      //     this.showModal = event.detail.modal
      //     return event.detail.modal;
      //   });
      // }
    },
  }
</script>

<style scoped>
#columnas{
  column-count:3;
  column-gap:40px;
  column-rule:4px dotted gray;
}
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
::v-deep .modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 90%;
  margin: 0 7rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  height: 100%;
  overflow-y: auto;
}
.modal__title {
  margin: 0 2rem 0 0;
  font-size: 1.5rem;
  font-weight: 700;
}
.modal__content {
  flex-grow: 1;
  overflow-y: auto;
}
.modal__action {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  padding: 1rem 0 0;
}
.modal__close {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
}
  .home {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    font-family: 'Readex Pro', sans-serif;
  }
  .body {
    width: 100%;
    height: 600px;
    display: flex;
  }
  .body__containt {
    height: calc(100vh - 120px);
    box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.1);
  }
  .body__sidebar {
    width: var(--sidebar-width, 280px);
    position: relative;
    display: flex;
    flex-direction: column;
  }

  .body__sidebar .floating-icon {
    position: absolute;
    right: -16px;
    top: 24px;
    z-index: 40;
  }
  .page__title .floating-icon{
    position: static;
    right: auto;
    top: auto;
  }

  .page__title{
    display: flex;
    align-items: center;
    gap: 14px;
    overflow: visible;
  }
  .hidden-sidebar{
    display: none;
  }

  .body__sidebar .title {
    width: 100%;
    height: 96px;
    border-bottom: 1px solid #e4e4e4;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 16px;
  }
  .body__sidebar.open{
    width: 0 !important;
    min-width: 0 !important;
    opacity: 0;
    overflow: hidden !important;
    pointer-events: none;
    visibility: hidden;
    border: none;
  }
  .body__sidebar .title__icon {
    color: #ff3128;
    font-size: 20px;
  }
  .body__sidebar .title__text {
    margin: 0 10px;
  }

  .body__sidebar .title__text h2 {
    font-size: 17px;
    margin: 0;
    line-height: 1.25;
  }
  .body__sidebar .title__text p {
    margin: 4px 0 0;
    font-weight: 300;
    font-size: 13px;
    color: #888;
  }

  .body__sidebar .tabs {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: calc(100% - 96px);
    padding-top: 8px;
  }

  .body__sidebar .tabs .tab {
    width: calc(100% - 24px);
    height: 48px;
    border-radius: 8px;
    color: #707070;
    display: flex;
    align-items: center;
    padding: 0 14px;
    margin-bottom: 6px;
    cursor: pointer;
    transition: 0.2s ease;
    text-decoration: none;
  }
  .body__sidebar .tabs .tab:hover,
  .body__sidebar .tabs .tab.active {
    color: #ff3128;
    background: #ffeeed;
  }

  .body__sidebar .tabs .tab__icon {
    font-size: 16px;
    margin-right: 8px;
  }

  .body__sidebar .tabs .tab__text p {
    margin: 0;
    font-weight: 600;
    font-size: 14px;
  }

  .body__containt {
    min-height: 87vh;
    height: fit-content;
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 20px 30px;
  }

  .body__containt .page__title {
    width: 100%;
    margin-bottom: 20px;
  }

  .body__containt .page__title h2 {
    font-weight: 600;
    color: #ff3128;
    font-size: 25px;
  }

  .body__containt .page__filters {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 20px;
    margin-bottom: 40px;
  }
  .body__containt .page__filters input,
  select {
    border-radius: 10px;
    border: 1px solid #e4e4e4;
    background: #fff;
    padding: 15px 20px;
    /* margin: 0 10px; */
  }

  .body__containt .page__buttons {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    gap: 20px;
  }

  .body__containt .page__buttons .button {
    width: 250px;
    padding: 15px 20px;
    border-radius: 15px;
    font-size: 17px;
    color: #fff;
    border: none;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .body__containt .page__buttons .button:nth-child(1) {
    background: #32ba7c;
  }
  .body__containt .page__buttons .button:nth-child(2) {
    background: #ff3128;
  }
  .body__containt .page__buttons .button:nth-child(3) {
    background: #262626;
  }

  .body__containt .page__table {
    width: 100%;
    min-height: 200px;
    display: flex;
    flex-direction: column;
    margin-top: 50px;
  }

  .body__containt .page__table .table-headers {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    border-bottom: 1px solid #b6b6b6;
  }
  .body__containt .page__table .table-headers p {
    width: calc(100% / 7);
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
  }

  .body__containt .page__table .table-body {
    width: 100%;
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid #b6b6b6;
  }

  .body__containt .page__table .table-body .data {
    width: 100%;
    display: flex;
  }
  .body__containt .page__table .table-body .data p {
    width: calc(100% / 7);
    justify-content: center;
    align-items: center;
    font-weight: 300;
    margin: 10px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
    padding: 0 1rem;
  }
  .body__containt .page__table .table-body .data p:nth-child(1) {
    color: #ff3128;
  }


/*-----FILTERS------*/
.body__containt .page__filters {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 40px;
}

.body__containt .page__filters .input {
  width: 300px;
  border-radius: 10px;
  border: 1px solid #938f8f;
  display: flex;
  flex-direction: column;
  padding: 7px 15px;
  transition: 0.4s ease;
}

.body__containt .page__filters .input:hover {
  box-shadow: 10px 15px 15px rgba(0, 0, 0, 0.05);
}
.body__containt .page__filters .input:nth-child(5) {
  /*margin-right: 320px;*/
}
.body__containt .page__filters.first .input:nth-last-child(1) {
  width: 1260px;
}
.body__containt .page__filters .input span {
  font-size: 15px;
  color: #938f8f;
}
.body__containt .page__filters .input p {
  margin: 0;
}
.back_company {
  background: #000;
  color: white;
  width: 100%;
  padding-top: 3%;
  padding-left: 10%;
}
/* INICIO MOBILE*/
@media (max-width: 768px){
  .body__containt .page__title h2{
    font-size: 21px;
  }
  .body__containt .page__filters input{
    padding: 5px 20px;
  }
  .page__filters select{
    padding: 10px 19px;
    width: 54% !important;
  }
  .body label{
    margin-top: 2rem;
    margin-left: 18px;
    font-size: 13px;
  }
  .body p.clean_filter{
    margin-top: 7px;
    font-size: 14px;
  }
  .buttonExport{
    margin-top: -13px;
    width: 179px;
    padding: 9px 20px;
  }
  .body__containt .page__table{
    font-size: 11px;
  }
  .body__containt .page__table .table-headers{
    margin-top: 6px;
    width: 245%;
  }
  .body__containt .page__table .table-body{
    width: 245%;
  }
  .body__containt .page__table .table-body{
    width: 245%;
  }
  .body__sidebar .title__text h2 {
    font-size: 18px;
  }
  .body__sidebar .title__text {
    margin: 0 10px;
    font-size: 16px;
  }
  .body__sidebar .title__icon{
    font-size: 16px;
    margin-left: 6px;
  }
  .body__sidebar .tabs .tab__icon svg{
    font-size: 15px;
    margin-right: 7px;}
  .body__sidebar .tabs .a{
    margin-left: -2px;
    margin-top: -1px;
  }
  .body__sidebar a svg{
    font-size: 22px;
  }
  /*BARRA LATERAL IZQUIERDA MOBILE*/
  .body__sidebar .tabs .tab__icon {
    color: white;
  }
  .body__sidebar .tabs .tab:hover, .body__sidebar .tabs .tab.active svg {
    color: #ff3128;
  }
  .body__sidebar .tabs .tab:hover, .body__sidebar .tabs .tab.active p {
    color: #ff3128;
    font-size: 20px;
  }
  .body__sidebar .tabs .tab__text p {
    margin-left: -8px;
    color: white;
    font-size: 18px;
  }
  .body__sidebar .tabs .tab:hover, .body__sidebar .tabs .tab.active{
    background: #262626;
    margin-bottom: -11px;
  }
  .body__containt .page__buttons .button{
    font-size: 13px;
    padding: 5px 20px;
    margin-top: -18px;
  }
  .body__containt .page__buttons {
    width: 105%;
  }
  .home .body .nav-mob-resp{
    position: absolute;
    background: #262626;
    height: 85vh;
    width: 25vh;
  }
  .body__sidebar .title {
    color: white;
  }
  .body__sidebar .floating-icon {
    position: absolute;
    right: -35px;
  }
  .body__sidebar .tabs .tab{
    margin-bottom: -7px;
  }
}

</style>
